import {
  Button,
  FormMessage,
  FormMessageVariant,
} from '@aus-platform/design-system';
import React from 'react';
import { SetupSteps } from 'shared/components';
import type { SecurityNotConfiguredProps } from '../types';

export const SecurityNotConfigured: React.FC<SecurityNotConfiguredProps> = ({
  isLoading = false,
  onConfigure,
}) => {
  return (
    <div className="settings-content">
      <div className="settings-content__body security-tab__not-configured">
        <FormMessage
          variant={FormMessageVariant.Warning}
          className="security-tab__callout"
          message={
            <>
              <h4 className="security-tab__callout__title">
                Two-Factor Authentication Not Configured
              </h4>
              <p className="security-tab__callout__description">
                Your account is not protected with two-factor authentication.
              </p>
            </>
          }
        />

        <div className="security-tab__not-configured__setup">
          <h3 className="security-tab__not-configured__setup__title">
            Configure Two-Factor Authentication
          </h3>
          <p className="security-tab__not-configured__setup__description">
            Two-Factor adds an extra layer of security by requiring a
            verification code from your authenticator app in addition to your
            log in.
          </p>

          <SetupSteps />
        </div>
      </div>

      <div className="settings-content__footer">
        <Button onClick={onConfigure} isLoading={isLoading}>
          Configure 2FA
        </Button>
      </div>
    </div>
  );
};
